/* Atlas "As featured on" (sections/atlas-home-press.liquid): evens out the press logos. Each file is read into a
   canvas, the empty space around the mark is trimmed, and the mark is redrawn in one grey. Its width / height then
   comes from the mark itself, and a dense, heavy mark is drawn a touch smaller than a light one, so all of them look
   the same size. If a file can't be read (no CORS), the logo keeps the plain sizing from the CSS. */
(function () {
  var INK = [20, 20, 19];
  function read(src) {
    return new Promise(function (ok, no) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { ok(im); };
      im.onerror = no;
      im.src = src;
    });
  }
  function trim(im) {
    var W = im.naturalWidth || 600, H = im.naturalHeight || 200;
    var k = Math.min(1, 800 / W);
    W = Math.max(1, Math.round(W * k)); H = Math.max(1, Math.round(H * k));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data;
    /* background from the corners: see through, or a solid colour */
    var corners = [0, (W - 1) * 4, (H - 1) * W * 4, ((H - 1) * W + W - 1) * 4];
    var clear = corners.every(function (i) { return d[i + 3] < 24; });
    var bl = 0; corners.forEach(function (i) { bl += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; }); bl /= 4;
    var ink = new Float32Array(W * H), x0 = W, y0 = H, x1 = -1, y1 = -1, sum = 0;
    for (var y = 0; y < H; y++) {
      for (var X = 0; X < W; X++) {
        var p = (y * W + X), i = p * 4, a = d[i + 3] / 255, v;
        if (clear) v = a;
        else { var l = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; v = a * Math.max(0, Math.abs(bl - l) / Math.max(bl, 255 - bl, 1)); }
        ink[p] = v;
        if (v > 0.1) { sum += v; if (X < x0) x0 = X; if (X > x1) x1 = X; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
    }
    if (x1 < 0) return null;
    /* the darkest part of every mark comes out the same, so a pale grey logo matches a black one */
    var top = 0;
    for (var t = 0; t < ink.length; t++) if (ink[t] > top) top = ink[t];
    if (top > 0 && top < 1) { for (var u = 0; u < ink.length; u++) ink[u] /= top; sum /= top; }
    var cw = x1 - x0 + 1, ch = y1 - y0 + 1;
    var o = document.createElement('canvas'); o.width = cw; o.height = ch;
    var ox = o.getContext('2d'), od = ox.createImageData(cw, ch);
    for (var yy = 0; yy < ch; yy++) {
      for (var xx = 0; xx < cw; xx++) {
        var q = (yy * cw + xx) * 4, v2 = ink[(yy + y0) * W + xx + x0];
        od.data[q] = INK[0]; od.data[q + 1] = INK[1]; od.data[q + 2] = INK[2]; od.data[q + 3] = Math.round(Math.min(1, v2) * 255);
      }
    }
    ox.putImageData(od, 0, 0);
    return { url: o.toDataURL('image/png'), ratio: cw / ch, density: sum / (cw * ch) };
  }
  function even(root) {
    var logos = [].slice.call(root.querySelectorAll('[data-press-logo]'));
    Promise.all(logos.map(function (el) {
      var img = el.querySelector('img');
      if (!img) return null;
      var src = img.currentSrc || img.src;
      return read(src).then(trim).catch(function () { return null; });
    })).then(function (res) {
      var ds = res.filter(Boolean).map(function (r) { return r.density; }).sort(function (a, b) { return a - b; });
      var mid = ds.length ? ds[Math.floor(ds.length / 2)] : 0;
      res.forEach(function (r, n) {
        if (!r) return;
        var el = logos[n], img = el.querySelector('img');
        /* heavy marks a little smaller, light ones a little bigger */
        var w = mid ? Math.min(1.18, Math.max(0.85, Math.pow(mid / r.density, 0.3))) : 1;
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = r.url;
        el.style.setProperty('--r', r.ratio.toFixed(3));
        el.style.setProperty('--w', w.toFixed(3));
        el.style.width = 'calc(sqrt(var(--pa) * var(--r)) * var(--s) * var(--w) * 1px)';
        el.style.height = 'calc(sqrt(var(--pa) / var(--r)) * var(--s) * var(--w) * 1px)';
        el.classList.add('is-even');
      });
    });
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-press]').forEach(even); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
